import {
  OnboardingStepStatusEnum,
  type OnboardingJourney,
  type OnboardingStep
} from 'src/api/main'

/** The journey plus the one thing about it that depends on what time it is. */
export type JourneyView = {
  journey: OnboardingJourney
  /** Snoozed, and the snooze has not run out yet. */
  isSnoozed: boolean
}

/**
 * Reads the clock so the widget does not have to.
 *
 * `hidden_until` is a timestamp, and "is it in the past yet?" is a moving
 * answer — read during render it is impure, which the React Compiler's lint
 * rules reject outright. Passed to `useQuery` as `select`, the question is
 * answered once per response and the component only ever tests a boolean.
 */
export const toJourneyView = (journey: OnboardingJourney): JourneyView => ({
  journey,
  isSnoozed:
    journey.hidden_until !== null &&
    Date.parse(journey.hidden_until) > Date.now()
})

/**
 * Whether a step is behind the user, either way. A skipped step is an answered
 * one — the counter would otherwise nag about a task the person has explicitly
 * declined. `failed` is deliberately not settled: that one still wants doing.
 */
export const isStepSettled = (step: OnboardingStep): boolean =>
  step.status === OnboardingStepStatusEnum.DONE ||
  step.status === OnboardingStepStatusEnum.SKIPPED
